function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.838 4c.2-.002.394.079.534.224.14.144.217.34.213.537v13.514c.514-.513 2.011-2.042 2.818-2.927a.733.733 0 0 1 1.278.276.752.752 0 0 1-.19.735c-.88.966-2.463 2.581-3.054 3.166-.315.312-1.026.986-1.074 1.034a.73.73 0 0 1-1.033 0c-.05-.048-.76-.722-1.075-1.034-.591-.585-2.175-2.2-3.053-3.164a.758.758 0 0 1-.152-.786.733.733 0 0 1 1.232-.235c.812.892 2.31 2.422 2.825 2.935V4.765a.756.756 0 0 1 .207-.536.734.734 0 0 1 .524-.229z",
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
});

var SvgIconDown = function SvgIconDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-down.448441c3.svg";
export { ForwardRef as ReactComponent };